import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import { TOUR_SELECTOR } from 'ui/partials/Tour';
import Content from 'ui/components/common/Tour/Content';

const useGetHowToManageBookingSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const createEventSteps: StepType[] = [
    {
      content: 'Go to the Calendar menu tab',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 500);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Booking to view the Calendar Booking view page.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 1000);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content:
        'In Bookings page, select the booking you want to manage by clicking on the 3 dots.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.MANAGE.EDIT}"]`,
      disableActions: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 500);
          },
          false,
        );
      },
      position: 'left',
    },
    {
      content: 'Then select Edit.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.MANAGE.EDIT_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 600);
          },
          false,
        );
      },
      position: 'left',
    },
    {
      content: (props) => (
        <Content
          {...props}
          // eslint-disable-next-line max-len
          content="Edit the booking details, add notes, manage attendees, or cancel the booking if needed"
          type="edit booking"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.FORM.FORM}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(5), 500);
          },
          false,
        );
      },
      position: 'top',
      stepInteraction: false,
    },
    {
      content: 'Click Save, and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
            setIsOpen(false);
          },
          false,
        );
      },
      position: 'left',
    },
  ];

  const showManageBookingSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(createEventSteps);
      setIsOpen(true);
    }, 300);
  };

  return showManageBookingSteps;
};

export default useGetHowToManageBookingSteps;
